export const Colors = {
    primaryLight: '#6584EA',
    primary: '#3B65EF',
    primaryDark: '#0b2886',
    secondary: '#FFFFFF',

    textDark: '#343c4a',
    textMenu: '#627496',
    text: '#546077',
    textLight: '#80899a',
    textLighter: '#abb1bc',
    textLightest: '#d5d8de',

    border: '#e4e8ee',
    borderLight: '#F0F3F9',

    primaryText: '#0f36b5',
    primarySelected: 'rgba(15,54,181,0.1)',
    primaryHover: 'rgba(15,54,181,0.2)',
    primaryPress: 'rgba(15,54,181,0.4)',

    hover: '#EEF2F6',
    active: '#DDE5ED',

    positive: '#40B8A8',
    negative: '#F13B4D',
    observe: '#ff9f43',
    mystery: '#B974FF',

    frame: '#C6C6D8',
    white: '#fff',
};
